import applicationsAPI from '~/api/v2/applications';
import amlchecks from '~/api/amlchecks';
import addonsAPI from '~/api/addons';
import secclAPI from '../api/seccl';

export const emptyAmlData = Object.freeze({
  address_detail: {
    address_1: null,
    address_2: null,
    building_name: null,
    building_number: null,
    country: null,
    flat_number: null,
    post_code: null,
  },
  employer_details: {
    account_number: null,
    address_details: {
      flat_number: null,
      building_name: null,
      building_number: null,
      address_1: null,
      address_2: null,
      country: null,
      post_code: null,
    },
    name: null,
    registration_number: null,
    sort_code: null,
  },
  employment_status: null,
  marital_status: null,
  retirement_age: null,
});

export const emptyJisaChildData = Object.freeze({
  title: null,
  first_name: null,
  middle_name: null,
  last_name: null,
  date_of_birth: null,
  nationality: null,
  tax_domicile: null,
  address_detail: {
    address_1: null,
    address_2: null,
    building_name: null,
    building_number: null,
    country: null,
    flat_number: null,
    post_code: null,
  },
});

export default {
  namespaced: true,

  state: () => ({
    applications: [],
    applicationsMeta: {},
    application: {},
    amlChecks: [],
    amlCheck: {},
    secclClient: {},
    secclNationalities: [],
  }),

  getters: {
    getApplication(state) {
      return state.application;
    },
    getApplications(state) {
      return state.applications;
    },
    getAMLCheck(state) {
      return state.amlcheck;
    },
    getAMLChecks(state) {
      return state.amlchecks;
    },
    getSecclClient(state) {
      return state.secclClient;
    },
    getSecclNationalities(state) {
      return state.secclNationalities;
    },
  },

  actions: {
    async getApplications({ commit }, { account_uuid, page = 1, per_page = 15 }) {
      const rsp = await applicationsAPI.getAll({ params: { page: page, per_page: per_page, 'filter[account_uuids]': account_uuid } });
      commit('SET_APPLICATIONS', rsp.data.data);
      commit('SET_APPLICATIONS_META', rsp.data.meta);
      return rsp;
    },
    async getApplication({ commit }, { application_uuid }) {
      const rsp = await applicationsAPI.getApplication(application_uuid);
      commit('SET_APPLICATION', rsp.data.data);
      return rsp.data.data;
    },
    async createApplication({ commit }, { data }) {
      const rsp = await applicationsAPI.createApplication(data);
      commit('SET_APPLICATION', rsp.data.data);
      return rsp.data.data;
    },
    async updateApplication({ commit }, { application_uuid, data }) {
      const rsp = await applicationsAPI.updateApplication(application_uuid, data);
      commit('SET_APPLICATION', rsp.data.data);
      return rsp.data.data;
    },
    async getAMLChecks({ commit }, { account_uuid }) {
      const rsp = await amlchecks.getAMLChecks(null, account_uuid);
      commit('SET_AMLCHECKS', rsp);
      return rsp;
    },
    async getAMLCheck({ commit }, { check_uuid, account_uuid }) {
      const rsp = await amlchecks.getAMLCheck(check_uuid, account_uuid);
      commit('SET_AMLCHECK', rsp.data.data);
      return rsp.data.data;
    },
    async createAMLCheck({ commit }, { data, account_uuid }) {
      const rsp = await amlchecks.createAMLCheck(data, account_uuid);
      commit('SET_AMLCHECK', rsp.data.data);
      return rsp.data.data;
    },
    async updateAMLCheck({ commit }, { data, check_uuid, account_uuid }) {
      const rsp = await amlchecks.updateAMLCheck(data, check_uuid, account_uuid);
      commit('SET_AMLCHECK', rsp.data.data);
      return rsp.data.data;
    },
    async deleteAMLCheck({ commit }, { check_uuid, account_uuid }) {
      const rsp = await amlchecks.deleteAMLCheck(check_uuid, account_uuid);
      commit('CLEAR_AMLCHECK');
      return rsp;
    },
    async getSecclClient({ commit }, { platform, client_uuid, store = true }) {
      const rsp = await addonsAPI.secclClient(platform, client_uuid);
      if (store) commit('SET_SECCL_CLIENT', rsp.data.data);
      return rsp.data.data;
    },
    async getSecclNationalities({ commit }, { platform }) {
      const rsp = await secclAPI.proxyCall(platform, 'static/nationality');
      commit('SET_SECCL_NATIONALITIES', rsp.data.data);
      return rsp.data.data;
    },
    async clearApplication({ commit }) {
      commit('CLEAR_APPLICATION');
    },
    async generateApplication({ commit, state }, { applicationUuid }) {
      const rsp = await applicationsAPI.generate(applicationUuid);
      const updatedApplication = rsp.data.data;
      commit('SET_APPLICATION', updatedApplication);

      return updatedApplication;
    },
  },

  mutations: {
    SET_APPLICATIONS(state, applications) {
      state.applications = applications;
    },
    SET_APPLICATIONS_META(state, meta) {
      state.applicationsMeta = meta;
    },
    SET_APPLICATION(state, application) {
      state.application = application;
    },
    CLEAR_APPLICATION(state) {
      state.application = {};
    },
    CLEAR_APPLICATIONS(state) {
      state.applications = [];
    },
    SET_AMLCHECKS(state, amlchecks) {
      state.amlChecks = amlchecks;
    },
    SET_AMLCHECK(state, amlcheck) {
      state.amlCheck = amlcheck;
    },
    SET_SECCL_CLIENT(state, secclClient) {
      state.secclClient = secclClient;
    },
    SET_SECCL_NATIONALITIES(state, secclNationalities) {
      state.secclNationalities = secclNationalities;
    },
    CLEAR_AMLCHECK(state) {
      state.amlCheck = {};
    },
  },
};
